import {
  Demographic,
  DevicesFields,
  Location,
  Personal,
  Professional,
} from '../components/ProfileFields';

export const steps: Record<string, React.ReactNode> = {
  Demographic: <Demographic />,
  DevicesFields: <DevicesFields />,
  Location: <Location />,
  Personal: <Personal />,
  Professional: <Professional noLinkedinConnection />,
};

export const orderedSteps = [
  'Location',
  'Demographic',
  'Personal',
  'Professional',
  'DevicesFields',
];
